export const TEXT_CONSTANTS = {
    // Add constants here as we discover them
    COMMON: {
        CANCEL: 'Cancelar',
        ACCEPT: 'Aceptar',
        SAVE: 'Guardar',
        DELETE: 'Eliminar',
        EDIT: 'Editar',
        CLOSE: 'Cerrar',
        LOADING: 'Cargando...',
        NO_DATA: 'No hay datos para mostrar',
        ERROR: 'Ocurrió un error',
        SUCCESS: 'Operación exitosa',
        INFO: 'Aviso',
        ACTIONS: 'Acciones',
        FILTER: 'Filtrar',
        EXPORT: 'Exportar',
        DOWNLOAD: 'Descargar',
        TODAY: 'Hoy',
        SELECT_PLACEHOLDER: 'Seleccionar...',
        SELECT_ALL: 'Seleccionar todo',
        NO_RESULTS: 'No se encontraron resultados',
        SELECTED: 'seleccionado',
        SELECTED_PLURAL: 'seleccionados',
        SEARCH: 'Buscar',
        MONTHS: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        CONSTRUCTION: 'Página en construcción'
    },
    VALIDATION: {
        REQUIRED: 'Este campo es requerido',
        INVALID_EMAIL: 'Email inválido',
        PASSWORDS_DO_NOT_MATCH: 'Las contraseñas no coinciden',
        MIN_LENGTH: 'Debe tener al menos {0} caracteres'
    },

    DASHBOARD: {
        TITLE: 'Inicio',
        WELCOME_MESSAGE: 'Hola {0}!',
        SUBTITLE_MOBILE: 'Mirá tus gastos',
        SUBTITLE_DESKTOP: 'Mirá tus balances y gastos',
        TOTAL_BALANCE: 'Balance de {0}',
        INCOME: 'Ingresos Mensuales',
        EXPENSES: 'Gastos Mensuales',
        RECENT_TRANSACTIONS: 'Transacciones Recientes',
        VIEW_ALL: 'Ver todo',
        FINANCIAL_SUMMARY: 'Resumen Financiero',
        UPCOMING_DUE_DATES: 'Próximos vencimientos',
        NEW_TRANSACTION_BUTTON: 'Nueva transacción',
        NO_INFO_MONTH: 'No hay información registrada en {0} {1}',
        PLACEHOLDER_MONTH: 'Mes',
        PLACEHOLDER_YEAR: 'Año',
        EXPENSES_BY_CATEGORY: 'Gastos por Categoría',
        TOP_CATEGORIES_BADGE: 'Top 5',
        THIS_MONTH: 'Este mes',
        AVERAGE: 'Promedio',
        NO_DATA_CHART: 'No hay datos para mostrar',
        NO_MONTHLY_DATA_LOG: 'No hay datos mensuales para mostrar',
        GO_TO_CURRENT_MONTH: 'Ir al mes actual',
        GO_TO_PREVIOUS_MONTH: 'Ver mes anterior',
        GO_TO_NEXT_MONTH: 'Ver mes siguiente',
        WHATSAPP_BANNER_TITLE: '¿Sabías que podés hablarle a Fina por WhatsApp?',
        WHATSAPP_BANNER_SUBTITLE: 'Mandá un gasto y lo registramos al instante.',
        WHATSAPP_BANNER_CTA: 'Escribir ahora',
        WHATSAPP_BANNER_DISMISS: 'Cerrar',
        MP_BANNER_TITLE: '¡FINA ahora se conecta con Mercado Pago!',
        MP_BANNER_SUBTITLE: 'Importá automáticamente tus pagos, transferencias y compras en cuotas con tarjeta de crédito, sin cargarlos a mano.',
        MP_BANNER_CTA: 'Conectar Mercado Pago',
        MP_BANNER_DISMISS: 'Cerrar',
        BILLING_PERIOD_RANGE: '{0} {1} - {2} {3}',
        MONTHS_SHORT: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        BALANCE_TOOLTIP: 'Balance acumulado en pesos, incluyendo ingresos y gastos en ARS y USD convertidos',
        BALANCE_PARTIAL_TOOLTIP: 'Balance parcial: ingresos menos gastos pagados hasta el momento (ARS y USD convertidos)',
        EXPENSES_PARTIAL_TOOLTIP: 'Gastos pagados hasta el momento. El estimado se calcula con el promedio de los últimos 3 meses'
    },
    TRANSACTIONS: {
        TITLE: 'Transacciones',
        NEW_TRANSACTION: 'Nueva Transacción',
        NEW_INCOME: 'Nuevo Ingreso',
        NEW_EXPENSE: 'Nuevo Gasto',
        EDIT_TRANSACTION: 'Editar Transacción',
        SEARCH_PLACEHOLDER: 'Buscar transacción',
        DATE: 'Fecha',
        CATEGORY: 'Categoría',
        DESCRIPTION: 'Descripción',
        AMOUNT: 'Monto',
        TAGS: 'Etiquetas',
        PLACEHOLDER_AMOUNT: '0.00',
        TYPE: 'Tipo',
        TYPE_EXPENSE: 'Gasto',
        TYPE_INCOME: 'Ingreso',
        TYPE_SAVING: 'Ahorro',
        NO_CATEGORY: 'Sin categoría',
        SELECT_CATEGORY: 'Seleccionar categoría',
        PROMPT_BUTTON: 'Prompt',
        PROMPT_TITLE: 'Describí tu transacción',
        PROMPT_PLACEHOLDER: 'Ej: Gasté $1000 en comida ayer',
        PROMPT_SUBMIT: 'Procesar',
        BACK_BUTTON: 'Volver',
        UPDATE_BUTTON: 'Actualizar',
        SAVE_BUTTON: 'Guardar',
        ADD_BUTTON: 'Agregar',
        PROMPT_SUBTITLE: 'Escribí lo esencial y Fina completa el resto',
        MANUAL_SUBTITLE: 'Ingresá tu transacción manualmente',
        OR_DIVIDER: 'ó',
        DELETE_CONFIRM_SINGLE: '¿Estás seguro de que deseas eliminar la transacción "{0}"?',
        DELETE_CONFIRM_MULTIPLE: '¿Estás seguro de que deseas eliminar {0} transacciones seleccionadas?',
        DELETE_WARNING: 'Esta acción no se puede deshacer.',
        DELETE_BUTTON: 'Eliminar',
        DELETING_BUTTON: 'Eliminando...',
        DELETE_MULTIPLE_BUTTON: 'Eliminar ({0})',
        TAG_MULTIPLE_BUTTON: 'Etiquetar ({0})',
        TAGGING_BUTTON: 'Etiquetando...',
        BULK_TAG_TITLE: 'Etiquetar transacciones',
        BULK_TAG_SUBTITLE: 'Se aplicarán a {0} transacciones seleccionadas',
        BULK_TAG_APPLY: 'Aplicar etiquetas',
        TAG_SUCCESS: 'Etiquetas aplicadas correctamente',
        TAG_ERROR: 'Error al aplicar las etiquetas',
        OPERATION_SUCCESS: 'Operación exitosa',
        OPERATION_FAILED: 'Operación fallida',
        CREATE_SUCCESS: 'La transacción se ha creado correctamente',
        UPDATE_SUCCESS: 'La transacción se ha actualizado correctamente',
        DELETE_SUCCESS: 'La transacción se ha eliminado correctamente',
        DELETE_ERROR: 'Error al eliminar transacciones',
        CREATE_ERROR: 'Error al crear la transacción',
        UPDATE_ERROR: 'Error al actualizar la transacción',
        EXPORT_SUCCESS: 'Exportación CSV iniciada',
        EXPORT_ERROR: 'Error al exportar CSV',
        NO_EXPORT_DATA: 'No hay transacciones para exportar',
        FILTER_ERROR: 'Error al aplicar los filtros',
        ADD_TAGS: 'Agregar etiquetas...',
        ORIGINAL_CURRENCY: 'Moneda original',
        CONVERTED_CURRENCY: 'Conversión a ARS',
        PROMPT_AI_TITLE: 'Crear con IA',
        SUBTITLE_NEW: 'Registrá un movimiento en segundos',
        SUBTITLE_EDIT: 'Editá los datos de la transacción',
        SUBTITLE_GROUP: 'Agregando a',
        TOTAL_LABEL: 'Total',
        FIXED_LABEL: 'Fijo',
        SHARED_EXPENSE_TOOLTIP: 'Gasto compartido',
        SHARE_WITH_GROUP: 'Compartir con grupo',
        SELECT_GROUP: 'Seleccionar grupo...',
        PAID_BY_QUESTION: '¿Quién pagó?',
        SPLIT_EQUAL: 'Equitativa',
        SPLIT_EXACT: 'Monto Exacto',
        SPLIT_PERCENTAGE: 'Porcentaje',
        ADD_ON_SHARE: 'Compartir',
        ADD_ON_LABEL: 'Agregar:',
        AI_GROUP_INFO: 'Fina va a dividir el gasto equitativamente.',
        PAID_LABEL: 'Pagó',
        OR_MANUAL: 'ó Manual',
        GENERATES_DEBT_LABEL: 'Marcar como deuda',
        GENERATES_DEBT_HINT_ON: 'Lo que le toca a cada uno se suma a quién le debe a quién.',
        GENERATES_DEBT_HINT_OFF: 'Se reparte para ver cuánto le toca a cada uno, pero no genera deuda.',
        OVERRIDE_SPLIT_LABEL: 'Cambiar solo para este gasto',
        WHO_LOADED_IT: '¿Quién lo cargó?',
        INCOME_GROUP_DESELECTED_HINT: 'Sacamos el grupo: los ingresos solo se pueden compartir con grupos en común.',
        NO_COMMON_GROUPS_HINT: 'No tenés grupos "Todo en común" para compartir un ingreso.',
        MY_INCOME_LINK: 'Tu ingreso',
        EMPTY_STATE: {
            TITLE: 'No hay transacciones para este mes',
            MESSAGE: 'Comenzá agregando tu primera transacción'
        },
        PAGINATION: {
            PREVIOUS: 'Anterior',
            NEXT: 'Siguiente',
            PER_PAGE: 'por página',
            OF: 'de',
            UNIT: 'transacciones',
        },
        SUMMARY: {
            BALANCE: 'Balance Neto',
            TRANSACTIONS: 'Transacciones',
            INCOME: 'Ingresos',
            EXPENSES: 'Egresos',
            TITLE_SPLIT: 'Balance por Moneda',
            TITLE_ARS: 'Balance en Pesos',
            TITLE_USD: 'Balance en Dólares',
            TOOLTIP_SPLIT: 'Balance neto separado por moneda',
            TOOLTIP_ARS: 'Balance neto del período convertido a pesos',
            TOOLTIP_USD: 'Balance neto de transacciones en dólares',
            CATEGORIES: 'Categorías',
            SEE_LESS: 'Ver menos',
            SEE_MORE: 'Ver más'
        }
    },
    ANALYTICS: {
        TITLE: 'Estadísticas',
        FILTERS: {
            LAST_7_DAYS: 'Últimos 7 días',
            LAST_30_DAYS: 'Últimos 30 días',
            BY_MONTH: 'Por mes',
            LAST_3_MONTHS: 'Últimos 3 meses',
            LAST_6_MONTHS: 'Últimos 6 meses',
            THIS_YEAR: 'Este año',
            PREVIOUS_YEAR: 'Año anterior',
            LABEL: 'Período:'
        },
        CHARTS: {
            EXPENSES_BY_CATEGORY: 'Gastos por categorías',
            EXPENSE_HISTORY: 'Historial de gastos',
            DAILY_CONSUMPTION: 'Consumos por día',
            BALANCE: 'Balance',
            TOP_FIXED: 'Top 5 gastos fijos',
            TOP_VARIABLE: 'Top 5 gastos variables',
            LOADING: 'Cargando datos...',
            AVERAGE_DAILY: 'Promedio diario',
            AVERAGE_WEEKLY: 'Promedio semanal',
            AVERAGE_MONTHLY: 'Promedio mensual',
            CASH_FLOW: 'Flujo de dinero',
            CASH_FLOW_INCOME_NODE: 'Ingresos',
            CASH_FLOW_FIXED_NODE: 'Gastos Fijos',
            CASH_FLOW_VARIABLE_NODE: 'Gastos Variables',
            CASH_FLOW_SAVINGS_NODE: 'Ahorro',
            CASH_FLOW_OTHERS_NODE: 'Otros',
            CASH_FLOW_EMPTY: 'No hay movimientos en este período'
        },
        HISTORY: {
            TITLE: 'Historial mensual',
            MONTH: 'Mes',
            INCOME: 'Ingresos',
            EXPENSES: 'Gastos variables',
            FIXED_EXPENSES: 'Gastos fijos',
            BALANCE: 'Balance',
            SAVINGS_PCT: '% Ahorro',
            EMPTY: 'No hay datos históricos disponibles.'
        },
        STATS: {
            TOTAL_EXPENSES: 'Gastos Totales',
            AVERAGE_DAILY: 'Gastos Promedio por Día',
            TOP_CATEGORY: 'Top Categoría'
        },
        AUTH_REQUIRED: {
            TITLE: 'Autenticación Requerida',
            MESSAGE: 'Necesitas iniciar sesión para ver los analytics.',
            BUTTON: 'Iniciar Sesión'
        }
    },
    SETTINGS: {
        TITLE: 'Configuración',
        CATEGORIES: {
            TITLE: 'Categorías',
            SUBTITLE: 'Decile a Fina tus categorías de interés.',
            NEW_CATEGORY: 'Nueva Categoría',
            DELETE_SUCCESS_TITLE: 'Operación exitosa',
            DELETE_SUCCESS_MESSAGE: 'Categoría eliminada con éxito',
            DELETE_ERROR_TITLE: 'Error',
            DELETE_ERROR_MESSAGE: 'No se pudo eliminar la categoría. Inténtalo de nuevo.',
            UPDATE_SUCCESS_TITLE: 'Operación exitosa',
            UPDATE_SUCCESS_MESSAGE: 'Categoría actualizada con éxito',
            CREATE_SUCCESS_TITLE: 'Operación exitosa',
            CREATE_SUCCESS_MESSAGE: 'Categoría creada con éxito'
        },
        PREFERENCES: {
            TITLE: 'Preferencias',
            SUBTITLE: 'Personalizá Fina a tu gusto',
            THEME: {
                LABEL: 'Tema',
                LIGHT: 'Claro',
                DARK: 'Oscuro'
            },
            THEME_SUCCESS: 'Tema actualizado correctamente',
            THEME_ERROR: 'Error al actualizar tema',
            DOLAR_TYPE: {
                LABEL: 'Tipo de dólar',
                OFFICIAL: 'Oficial',
                BLUE: 'Blue'
            },
            DOLAR_TYPE_SUCCESS: 'Tipo de dólar actualizado correctamente',
            DOLAR_TYPE_ERROR: 'Error al actualizar tipo de dólar',
            BILLING_START_DAY: {
                LABEL: 'Inicio del período',
                HELP: 'El día del mes en que comienza tu período financiero (ej: día de cobro)',
                DAY_PREFIX: 'Día'
            },
            BILLING_START_DAY_SUCCESS: 'Día de inicio del período actualizado correctamente',
            BILLING_START_DAY_ERROR: 'Error al actualizar el día de inicio del período'
        },
        INTEGRATIONS: {
            TITLE: 'Conexiones',
            SUBTITLE: 'Importá movimientos automáticamente desde otras apps',
            MERCADOPAGO: {
                NAME: 'Mercado Pago',
                DESCRIPTION: 'Importa tus pagos y cobros de Mercado Pago como gastos e ingresos',
                CONNECT: 'Conectar',
                CONNECTED: 'Conectado',
                DISCONNECT: 'Desconectar',
                SYNC_NOW: 'Sincronizar ahora',
                SYNCING: 'Sincronizando...',
                LAST_SYNCED: 'Última sincronización',
                NEVER_SYNCED: 'Todavía no sincronizaste',
                CONNECT_ERROR: 'No se pudo iniciar la conexión con Mercado Pago',
                STATUS_ERROR: 'No se pudo obtener el estado de la conexión',
                DISCONNECT_CONFIRM_TITLE: 'Desconectar Mercado Pago',
                DISCONNECT_CONFIRM_MESSAGE: 'Dejaremos de sincronizar tus pagos de Mercado Pago. Los movimientos ya importados no se eliminan.',
                DISCONNECT_SUCCESS: 'Mercado Pago desconectado',
                DISCONNECT_ERROR: 'No se pudo desconectar Mercado Pago',
                SYNC_SUCCESS: '{0} movimiento(s) nuevo(s) importado(s)',
                SYNC_SUCCESS_NONE: 'Ya estabas al día, no había movimientos nuevos',
                SYNC_ERROR: 'No se pudo sincronizar con Mercado Pago',
                CONNECTED_FROM_CALLBACK: '¡Mercado Pago conectado correctamente!',
                CALLBACK_ERROR: 'No se pudo conectar con Mercado Pago. Intentá de nuevo.',
                SYNC_PENDING_CARDS: '{0} compra(s) con tarjeta necesitan que elijas una tarjeta',
                PENDING: {
                    TITLE: 'Gastos detectados en Mercado Pago para asignar',
                    NOTICE: '{0} compra(s) con tarjeta de Mercado Pago esperan que las asignes a una tarjeta.',
                    GO_TO_CARDS: 'Ir a Tarjetas',
                    SUBTITLE: 'Detectamos estas compras en Mercado Pago pero no pudimos asociarlas a una de tus tarjetas.',
                    CARD_LABEL: 'Tarjeta de Fina',
                    CARD_PLACEHOLDER: 'Elegí una tarjeta',
                    NO_CARDS: 'Primero creá una tarjeta de crédito para poder asignar estas compras.',
                    ASSIGN: 'Asignar',
                    DISMISS: 'Descartar',
                    ENDING_IN: 'Terminada en',
                    INSTALLMENTS: '{0} cuota(s) de',
                    ASSIGN_SUCCESS: 'Compra asignada a la tarjeta',
                    ASSIGN_ERROR: 'No se pudo asignar la compra',
                    DISMISS_SUCCESS: 'Compra descartada',
                    DISMISS_ERROR: 'No se pudo descartar la compra',
                    LOAD_ERROR: 'No se pudieron cargar las compras pendientes',
                },
                CONTACTS: {
                    SHOW: 'Ver cuentas',
                    DETAIL_LABEL: 'Cuenta de Mercado Pago',
                    DETAIL_ID: 'ID',
                    NO_ALIAS: 'Sin alias',
                    EDIT_ALIAS: 'Editar alias',
                    ALIAS_HINT: 'Dejalo vacío para quitar el alias',
                    TITLE: 'Cuentas de Mercado Pago',
                    SUBTITLE: 'Cuentas a las que les pusiste alias. Para agregar uno nuevo, abrí una transacción de Mercado Pago.',
                    EMPTY: 'Todavía no le pusiste alias a ninguna cuenta. Podés hacerlo desde el detalle de una transacción de Mercado Pago.',
                    ALIAS: 'Alias',
                    ALIAS_PLACEHOLDER: 'Ej: Juan (alquiler)',
                    CATEGORY_LABEL: 'Categoría de las transacciones',
                    CATEGORY_HINT: 'Las transacciones que lleguen de esta cuenta se categorizan así automáticamente.',
                    NO_CATEGORY: 'Sin categoría (automática)',
                    TRANSACTIONS: '{0} movimiento(s)',
                    SAVE_SUCCESS: 'Cuenta actualizada',
                    SAVE_ERROR: 'No se pudo guardar la cuenta',
                    LOAD_ERROR: 'No se pudieron cargar las cuentas',
                },
            }
        },
        USER: {
            TITLE: 'Tus datos',
            SUBTITLE: 'Configurá tus datos de usuario',
            EMAIL: 'Email',
            PHONENUMBER: 'Número de teléfono',
            NAME: 'Nombre',
            LASTNAME: 'Apellido',
            USER_FIELD_UPDATE_SUCCESS_MESSAGE: 'Los datos se actualizaron correctamente',
            USER_FIELD_UPDATE_ERROR_MESSAGE: 'Error al actualizar los datos'
        },
        ACCOUNT: {
            TITLE: 'Cuenta',
            SUBTITLE: 'Gestioná tu cuenta de Fina.',
            CHANGE_PASSWORD: 'Cambiar contraseña',
            CHANGE_PASSWORD_SUBTITLE: 'Te enviaremos un correo electrónico para cambiar tu contraseña.',
            CHANGE_PASSWORD_BUTTON: 'Cambiar contraseña',
            CHANGE_PASSWORD_CONFIRM: '¿Estás seguro de que deseas cambiar tu contraseña?',
            CHANGE_PASSWORD_CONFIRM_MESSAGE: 'Te enviaremos un correo electrónico para cambiar tu contraseña.',
            CHANGE_PASSWORD_SUCCESS: 'Correo electrónico enviado correctamente',
            CHANGE_PASSWORD_ERROR: 'Error al enviar correo electrónico',
            DELETE_ACCOUNT: 'Eliminar cuenta',
            DELETE_ACCOUNT_SUBTITLE: 'Eliminar permanentemente tu cuenta de Fina y todos los datos asociados.',
            DELETE_ACCOUNT_BUTTON: 'Eliminar cuenta',
            DELETE_ACCOUNT_CONFIRM: '¿Estás seguro de que deseas eliminar tu cuenta?',
            DELETE_ACCOUNT_CONFIRM_MESSAGE: 'Esta acción no se puede deshacer. Tu cuenta será eliminada permanentemente.',
            DELETE_ACCOUNT_SUCCESS: 'Cuenta eliminada correctamente',
            DELETE_ACCOUNT_ERROR: 'Error al eliminar cuenta'
        }
    },
    CATEGORY_FORM: {
        TITLE_EDIT: 'Editar categoría',
        TITLE_NEW: 'Nueva categoría',
        DELETE_CONFIRM_TITLE: '¿Estás seguro de que deseas eliminar la categoría "{0}"?',
        DELETE_CONFIRM_MESSAGE: 'Esta acción no se puede deshacer. La categoría será eliminada permanentemente.',
        PLACEHOLDERS: {
            NAME: 'Nombre de la categoría',
            DESCRIPTION: 'Descripción (opcional)'
        },
        LABELS: {
            EMOJI: 'Emoji',
            COLOR: 'Color'
        }
    },
    FIXED_EXPENSES: {
        TITLE: 'Gastos Fijos',
        SUBTITLE: 'Gestiona tus gastos recurrentes y suscripciones',
        NEW_EXPENSE: 'Nuevo gasto fijo',
        EDIT_BUTTON: 'Editar',
        DELETE_BUTTON: 'Eliminar',
        DELETE_BUTTON_LOADING: 'Eliminando...',
        ACTIONS: {
            CREATE_SUCCESS: 'Gasto fijo creado correctamente',
            UPDATE_SUCCESS: 'Gasto fijo actualizado correctamente',
            DELETE_SUCCESS: 'Gasto fijo eliminado correctamente',
            TOGGLE_ACTIVE: 'Gasto fijo activado',
            TOGGLE_INACTIVE: 'Gasto fijo desactivado',
            PAY_SUCCESS: 'Pago de {0} registrado correctamente',
            SKIP_SUCCESS: 'Pago omitido correctamente',
            REVERT_SUCCESS: 'Pago revertido correctamente',
            LOAD_ERROR: 'Error al cargar los datos',
            LOAD_EXPENSES_ERROR: 'Error al cargar los gastos fijos',
            SAVE_ERROR: 'Error al guardar el gasto fijo',
            TOGGLE_ERROR: 'Error al cambiar el estado del gasto fijo',
            DELETE_ERROR: 'Error al eliminar el gasto fijo',
            PAY_ERROR: 'Error al registrar el pago',
            SKIP_ERROR: 'Error al omitir el pago',
            REVERT_ERROR: 'Error al revertir el pago'
        },
        CONFIRM: {
            DELETE_TITLE_MULTIPLE: '¿Estás seguro de que deseas eliminar los gastos fijos seleccionados?',
            DELETE_TITLE_SINGLE: '¿Estás seguro de que deseas eliminar el gasto fijo {0}?',
            DELETE_MESSAGE: 'Esta acción no se puede deshacer.',
            SKIP_TITLE: '¿Estás seguro de que deseas omitir este pago?',
            SKIP_BUTTON: 'Omitir Pago',
            REVERT_TITLE: '¿Estás seguro de que deseas revertir este pago?',
            REVERT_MESSAGE: 'Esta acción revertirá el pago de este mes y no se podrá deshacer.',
            REVERT_BUTTON: 'Revertir Pago'
        },
        FIXED_EXPENSES_SUMMARY: {
            TOTAL_MONTHLY: 'Total Mensual',
            PENDING: 'Pendientes',
            UPTODATE: 'Al día',
            OVERDUE: 'Atrasados',
            PROGRESS_TITLE_DEFAULT: 'Progreso del mes',
            PROGRESS_TITLE_ARS: 'Progreso en Pesos',
            PROGRESS_TITLE_USD: 'Progreso en Dólares',
            LEGEND_PAID: 'Pagado',
            LEGEND_PENDING: 'Pendiente',
            CATEGORIES_LABEL: 'Categorías:',
            STATUS_LABEL: 'Estado:',
            FILTER_PENDING: 'Pendientes',
            FILTER_OVERDUE: 'Vencidos',
            FILTER_UPTODATE: 'Al día',
            FILTER_SHARED: 'Compartidos'
        },
        STATS: {
            TOTAL_MONTHLY: 'Total mensual',
            PENDING: 'Pendientes',
            OVERDUE: 'Atrasados',
            UP_TO_DATE: 'Al día'
        },
        FAB: {
            USE_TEMPLATE: 'Usar plantilla',
            ADD_MANUAL: 'Agregar gasto fijo'
        },
        CATEGORIES: {
            ALL: 'Todos'
        },
        CALENDAR: {
            TITLE: 'Calendario de Vencimientos',
            NO_DATA: 'No hay vencimientos',
            SHOW: 'Calendario',
            HIDE: 'Ocultar'
        },
        EMPTY_STATE: {
            TITLE: 'Aún no tenés gastos fijos',
            MESSAGE: 'Registrá tus suscripciones, alquiler y servicios para hacer un seguimiento automático de los vencimientos.',
            NO_RESULTS_TITLE: 'Sin resultados',
            NO_RESULTS_MESSAGE: 'No hay gastos fijos que coincidan con los filtros aplicados.',
            CLEAR_FILTERS: 'Limpiar filtros'
        },
        EXPORT: 'Exportar',
        EXPORT_INVOICES: 'Descargar historial de pagos',
        EXPORT_SUCCESS: 'Exportación CSV iniciada',
        EXPORT_ERROR: 'Error al exportar CSV',
        NO_EXPORT_DATA: 'No hay pagos para exportar',
        CSV: {
            FILE_HEADER_NAME: 'Gasto',
            FILE_HEADER_CATEGORY: 'Categoría',
            FILE_HEADER_FREQUENCY: 'Frecuencia',
            FILE_HEADER_BASE_AMOUNT: 'Monto base',
            COL_DUE_DATE: 'Fecha de Vencimiento',
            COL_STATUS: 'Estado',
            COL_AMOUNT: 'Monto',
            COL_PAID_AT: 'Fecha de Pago',
            COL_NOTES: 'Notas',
            NO_CATEGORY: 'Sin categoría'
        },
        NEW_FIXED_EXPENSE: 'Nuevo gasto fijo',
        USE_TEMPLATE: 'Usar plantilla',
        ADD_MANUAL: 'Agregar manual',
        VIEW_LIST: 'Lista',
        VIEW_BOARD: 'Bloques',
        BOARD_EMPTY_COLUMN: 'Sin gastos',
        BOARD_MOVE_INVALID_TITLE: 'Movimiento no permitido',
        BOARD_MOVE_INVALID: 'Ese cambio de estado no es una acción válida',
        FILTERS: 'Filtros',
        FILTER_CATEGORIES: 'Categorías',
        FILTER_STATUS: 'Estado',
        FILTER_FREQUENCY: 'Frecuencia',
        FILTER_SHARED: 'Compartidos',
        SHARED_TOOLTIP: 'Gasto compartido',
        CLEAR: 'Limpiar',
        CANCEL: 'Cancelar',
        RESET: 'Restablecer',
        SEE_RESULTS: 'Ver resultados',
        SEARCH_PLACEHOLDER: 'Buscar gasto fijo',
        RESULT_COUNT_ONE: '1 gasto encontrado',
        RESULT_COUNT: '{count} gastos encontrados',
        LIST_EMPTY: 'No hay gastos fijos para mostrar',
        DUE: {
            NONE: 'Sin vencimiento',
            PAID: 'Pagado',
            SKIPPED: 'Saltado',
            PAUSED: 'Pausado',
            OVERDUE: 'Hace {count} días',
            TODAY: 'Vence hoy',
            IN_DAYS: 'Vence en {count} días'
        },
        ROW_ACTIONS: {
            PAY: 'Pagar',
            SKIP: 'Saltar',
            DETAIL: 'Ver detalle',
            EDIT: 'Editar',
            OPEN_LINK: 'Abrir enlace'
        },
        FREQUENCY_FILTER: {
            MONTHLY: 'Mensual',
            ANNUAL: 'Anual',
            WEEKLY: 'Semanal',
            ONE_TIME: 'Única vez'
        },
        STATUS_GROUP: {
            OVERDUE: 'Atrasado',
            PENDING: 'Pendiente',
            PAID: 'Pagado',
            SKIPPED: 'Saltado',
            PAUSED: 'Pausado'
        },
        STATUS_FILTER: {
            ALL: 'Todos',
            PENDING: 'Pendientes',
            OVERDUE: 'Atrasados',
            PAID: 'Pagados',
            SKIPPED: 'Saltados'
        },
        NO_INSTALLMENTS: 'Sin cuotas registradas',
        VIEW_INSTALLMENTS: 'Cuotas',
        INSTALLMENTS: {
            EXPENSE: 'Gasto',
            CATEGORY: 'Categoría',
            TOTAL: 'Total',
            INSTALLMENT: 'Cuota',
            REMAINING: 'Restantes',
            SUBSCRIPTION: 'Suscripción',
            INCOME: 'Ingreso',
            OF: 'de'
        }
    },
    CARDS: {
        TITLE: 'Tus tarjetas',
        SUBTITLE: 'Llevá un registro de tus consumos y cuotas',
        OVERVIEW_TOTAL: 'Total entre tarjetas',
        OVERVIEW_CARDS_COUNT: 'tarjetas',
        PAY_IN_FIXED_EXPENSES: 'Pagar en Gastos Fijos',
        NEXT_INSTALLMENTS: 'Mis consumos',
        ACTIVE_INSTALLMENTS: 'Resumen actual',
        CURRENT_RESUME: 'Resumen',
        NEXT_RESUME: 'Próximo',
        HISTORIC_RESUMES: 'Historial de Pagos',
        NEW_CONSUMPTION: 'Nuevo consumo',
        NEW_CONSUMPTION_SUBTITLE: 'Registra un consumo en tu tarjeta',
        STATEMENT_ADJUSTMENTS: 'Intereses e impuestos',
        CREDIT_LIMIT: 'Límite de crédito',
        PAYMENT_FREQUENCIES: {
            MONTHLY: 'Mensual',
            YEARLY: 'Anual'
        },
        FORM: {
            NAME: 'Nombre',
            CATEGORY: 'Categoría',
            AMOUNT: 'Monto',
            FREQUENCY: 'Frecuencia',
            PAYMENT_DATE: 'Fecha de pago',
            INSTALLMENTS: 'Cuotas',
            INTERESTS: 'Intereses',
            PAYMENT_SUMMARY: 'Resumen',
            VALUE_PER_INSTALLMENT: 'Valor por cuota',
            TOTAL_AMOUNT: 'Total',
            SUBSCRIPTION: 'Suscripción',
            PAID_INSTALLMENTS: 'Cuotas pagas',
        },
        ERROR_MESSAGE: 'Error al obtener los datos de las tarjetas',
        ERROR_MESSAGE_ACTIVE_CONSUMPTIONS: 'No se pudieron obtener los consumos activos',
        ERROR_MESSAGE_SUMMARY: 'No se pudo obtener el resumen',
        NO_CARDS_ERROR_TITLE: 'Todavía no tenés tarjetas',
        NO_CARDS_ERROR_MESSAGE: 'Creá una tarjeta primero para poder registrar un consumo.',
        VIEW_COMBINED_DASHBOARD: 'Ver Gastos Combinados',
    },
    CARDS_DASHBOARD: {
        TITLE: 'Dashboard de tarjetas',
        SUBTITLE: 'Todos tus consumos combinados, en un solo lugar',
        BACK_TO_CARDS: 'Volver a tarjetas',
        TOTAL_LABEL: 'Total combinado',
        PENDING_INSTALLMENTS_LABEL: 'Total cuotas pendientes',
        TOTAL_USD_LABEL: 'Total en dólares',
        TOTAL_HINT: 'Este período, {0} tarjeta(s)',
        TOTAL_USD_HINT: 'Consumos en moneda extranjera',
        PENDING_HINT: '{0} cuota(s) por pagar',
        TOTAL_SHORT: 'Total',
        CONSUMPTIONS_ONE: 'consumo',
        CONSUMPTIONS_MANY: 'consumos',
        PER_MONTH: '/ mes',
        ENDS: 'Termina',
        GO_TO_STAT: 'Ir a',
        BY_CARD: 'Por tarjeta',
        TIMELINE_TITLE: 'Proyección combinada',
        CONSUMPTIONS_TITLE: 'Consumos activos (todas las tarjetas)',
        ERROR_MESSAGE: 'Error al obtener el dashboard de tarjetas',
        NO_CARDS_TITLE: 'Todavía no tenés tarjetas',
        NO_CARDS_MESSAGE: 'Creá una tarjeta para ver tu dashboard combinado.',
    },
    AUTH: {
        LOGIN_TITLE: 'Iniciar sesión en',
        REGISTER_TITLE: 'Registrarse en',
        LOGOUT: 'Cerrar Sesión',
        COMPLETE_PROFILE_TITLE: 'Completá tu perfil',
        WELCOME_USER: 'Hola {0}!',
        COMPLETE_PROFILE_MSG: 'Solo necesitamos tu número de teléfono para completar tu registro. No incluyas 0, ni 15!',
        OR: 'o',
        USERNAME: 'Nombre de usuario',
        USERNAME_REQUIRED: 'El nombre de usuario es requerido',
        PASSWORD: 'Tu contraseña',
        CREATE_PASSWORD: 'Crea una contraseña',
        CONFIRM_PASSWORD: 'Confirma tu contraseña',
        PASSWORD_REQUIRED: 'La contraseña es requerida',
        PASSWORD_MIN_LENGTH: 'La contraseña debe tener al menos 6 caracteres',
        CONFIRM_PASSWORD_REQUIRED: 'La confirmación de contraseña es requerida',
        PASSWORD_MISMATCH: 'Las contraseñas no coinciden',
        FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
        LOGIN_BUTTON: 'Iniciar sesión',
        NO_ACCOUNT: '¿No tenés una cuenta?',
        REGISTER_HERE: 'Registrate acá',
        ALREADY_HAVE_ACCOUNT: '¿Ya tenés una cuenta?',
        LOGIN_HERE: 'Iniciá sesión acá',
        GOOGLE_LOGIN_ERROR: 'Error al hacer login con Google',
        GOOGLE_LOGIN_FAIL: 'No se pudo iniciar sesión con Google',
        LOGIN_SUCCESS: 'Login exitoso',
        LOGIN_ERROR: 'Credenciales incorrectas',
        LOGIN_ERROR_TITLE: 'No se pudo iniciar sesión',
        LOGIN_ERROR_MSG: 'Verificá tus credenciales e intentá nuevamente.',
        FIRST_NAME: 'Nombre',
        FIRST_NAME_REQUIRED: 'El nombre es requerido',
        LAST_NAME: 'Apellido',
        LAST_NAME_REQUIRED: 'El apellido es requerido',
        EMAIL: 'Tu correo electrónico',
        EMAIL_REQUIRED: 'El correo electrónico es requerido',
        EMAIL_INVALID: 'Ingresa un correo electrónico válido',
        PHONE_NUMBER: 'Número de teléfono',
        PHONE_NUMBER_REQUIRED: 'El número de teléfono es requerido',
        COMPLETE_REGISTER_BUTTON: 'Completar registro',
        CREATE_ACCOUNT_BUTTON: 'Crear cuenta',
        REGISTER_SUCCESS_TITLE: 'Operación exitosa',
        REGISTER_SUCCESS_MSG: 'Usuario registrado con éxito',
        REGISTER_ERROR_TITLE: 'Operación fallida',
        REGISTER_ERROR_MSG: 'Hubo un error al registrar el usuario'
    },
    SIDEBAR: {
        MENU_TITLE: 'Menú',
        DASHBOARD: 'Inicio',
        TRANSACTIONS: 'Transacciones',
        FIXED_EXPENSES: 'Gastos Fijos',
        ANALYTICS: 'Estadísticas',
        SETTINGS: 'Configuración',
        CARDS: 'Tarjetas',
        GROUPS: 'Grupos',
        WALLETS: 'Billeteras',
        ENVELOPES: 'Sobres',
        PRO: 'Hacete Pro',
        HELP: 'Ayuda',
        COLLAPSE: 'Colapsar',
        ADMIN: 'Administración'
    },
    CONFIRMATION: {
        CONFIRM_TEXT: 'Confirmar',
        CANCEL_TEXT: 'Cancelar'
    },
    FILTER_SELECTOR: {
        TITLE: 'Filtros',
        CLEAR_ALL: 'Limpiar todo',
        SHOW_RESULTS: 'Ver resultados',
        NO_ACTIVE: 'Sin filtros',
        ACTIVE_COUNT: '{0} filtros activos',
        SHOW_MORE: 'Mostrar más ({0})',
        SHOW_LESS: 'Mostrar menos',
        SECTION: {
            CATEGORIES: 'Categorías',
            PERIOD: 'Período',
            AMOUNT: 'Monto (ARS)',
            TYPE: 'Tipo',
            EXCLUDE: 'Excluir',
        },
        EXCLUDE_FIXED: 'Gastos Fijos',
        EXCLUDE_MOVEMENTS: 'Movimientos',
        TYPE_ALL: 'Todos',
        LABEL: {
            CATEGORY: 'Categoría',
            FROM: 'Desde',
            TO: 'Hasta',
            MIN_AMOUNT: 'Monto mín.',
            MAX_AMOUNT: 'Monto máx.',
            SHOW: 'Mostrar:',
            TAGS: 'Etiquetas'
        },
        PLACEHOLDER: {
            SELECT: 'Seleccionar...',
            ZERO: '0',
            INFINITY: '∞',
            TAGS: 'Filtrar por etiquetas...'
        },
        LIMIT: {
            ONE: '1 resultado',
            FIVE: '5 resultados',
            TEN: '10 resultados',
            TWENTY_FIVE: '25 resultados',
            FIFTY: '50 resultados',
            ONE_HUNDRED: '100 resultados',
            ALL: 'Todos'
        },
        ACTIONS: {
            RESET: 'Restablecer',
            APPLY: 'Aplicar filtros'
        },
        ACTIVE_FILTERS: {
            LABEL: 'Filtros:',
            START_DATE: 'Fecha inicio',
            END_DATE: 'Fecha fin',
            LIMIT: 'Límite',
            TAGS: 'Etiqueta'
        }
    },
    FIXED_EXPENSE_DETAIL: {
        COLUMNS: {
            DATE: 'Fecha',
            AMOUNT: 'Monto',
            NOTES: 'Notas'
        },
        STATS: {
            TOTAL_PAID: 'Total pagado',
            AVERAGE_PAID: 'Valor promedio'
        },
        HISTORY: {
            TITLE: 'Historial de pagos',
            NO_HISTORY: 'No hay pagos registrados',
            PAID_AT: 'Pagado el',
            SKIPPED_AT: 'Omitido el'
        },
        BADGES: {
            PAID: 'Pagados',
            PENDING: 'Pendientes',
            OVERDUE: 'Vencidos',
            SKIPPED: 'Omitidos'
        },
        STATUS: {
            PAID: 'Pagado',
            SCHEDULED: 'Próximo',
            PENDING: 'Pendiente',
            OVERDUE: 'Vencido',
            SKIPPED: 'Omitido'
        },
        ACTIONS: {
            PAY: 'Pagar',
            SKIP: 'Omitir',
            PAY_EARLY: 'Pagar antes',
            REVERT: 'Revertir'
        }
    },
    FIXED_EXPENSE_FORM: {
        TITLE: {
            NEW: 'Nuevo gasto fijo',
            EDIT: 'Editar gasto fijo',
            SUBTITLE_NEW: 'Configurá un servicio recurrente',
            SUBTITLE_EDIT: 'Actualizá los datos del servicio'
        },
        SUBMIT: {
            CREATE: 'Crear gasto fijo',
            UPDATE: 'Guardar cambios',
            SAVE: 'Guardar'
        },
        LABELS: {
            NAME: 'Nombre',
            CATEGORY: 'Categoría',
            AMOUNT: 'Monto',
            DESCRIPTION: 'Descripción',
            FREQUENCY: 'Frecuencia',
            AUTOMATIC: 'Automático',
            NEXT_PAYMENT: 'Próximo pago',
            REMINDER: 'Recordatorio',
            SHARE_WITH_GROUP: 'Compartir con un grupo',
            SELECT_GROUP: 'Seleccionar grupo',
            PAID_BY: 'Pagado por',
            SPLIT_TYPE: 'Tipo de división',
            SPLIT_EQUAL: 'Partes iguales',
            SPLIT_PERCENTAGE: 'Por porcentaje',
            SPLIT_EXACT: 'Monto exacto',
            SPLIT_CONFIG_TITLE: 'Configuración por miembro',
            URL: 'URL del servicio',
            AUTO_PAY_SUBTITLE: 'Registra el pago al vencimiento',
            SHARED_WITH: 'Compartido con {0}'
        },
        PLACEHOLDERS: {
            NAME: 'Ej: Netflix',
            CATEGORY: 'Seleccionar',
            DESCRIPTION: '(opcional)',
            SELECT_DAYS: 'Seleccionar días',
            URL: 'https://...',
            AMOUNT: '0,00',
            DATE: 'dd/mm/aaaa',
            FREQUENCY: 'Mensual'
        },
        REMINDER_DAYS: '{0} días antes',
        ADD_ON: {
            TITLE: 'Agregar:',
            REMINDER: 'Recordatorio',
            AUTO_PAY: 'Pago automático',
            SHARE: 'Compartir',
            URL: 'URL'
        },
        SPLIT: {
            EQUAL: 'Iguales',
            PERCENTAGE: 'Porcentaje',
            EXACT: 'Monto exacto'
        },
        STEPS: {
            NEXT: 'Siguiente',
            BACK: 'Atrás'
        }
    },
    TEMPLATE_CHOOSER: {
        TITLE: 'Elegí una plantilla',
        SUBTITLE: 'Empezá con un gasto fijo común para configurarlo más rápido',
        SEARCH_PLACEHOLDER: 'Buscar gasto fijo',
        CANCEL: 'Cancelar',
        CONTINUE: 'Continuar',
        LOAD_ERROR: 'Error al cargar las plantillas',
        NO_RESULTS: 'No se encontraron plantillas'
    },
    TEMPLATE_FORM: {
        ADD: 'Agregar',
        CANCEL: 'Cancelar'
    },
    FIXED_EXPENSE_PAYMENT_MODAL: {
        TITLE: 'Querés pagar {0}?',
        LABELS: {
            AMOUNT: 'Importe',
            NOTES: 'Notas (opcional)',
            UPDATE_AMOUNT: 'Actualizar monto'
        },
        PLACEHOLDERS: {
            NOTES: 'Agregá una nota'
        }
    },
    FIXED_EXPENSE_TABLE: {
        COLUMNS: {
            SERVICE: 'Servicio',
            AMOUNT: 'Monto',
            DUE_DATE: 'Vencimiento',
            CATEGORY: 'Categoría',
            PAYMENT_STATUS: 'Estado de Pago',
            PAYMENTS: 'Pagos',
            ACTIVE: 'Activo'
        },
        DUE_DATE: {
            OVERDUE: 'Hace {0} dias',
            TODAY: 'Hoy',
            IN_DAYS: 'En {0} dias'
        },
        EMPTY_STATE: {
            TITLE: 'No hay gastos fijos',
            MESSAGE: 'Agregá tu primer gasto fijo o suscripción'
        },
        FREQUENCY: {
            WEEKLY: 'Semanal',
            MONTHLY: 'Mensual',
            ANNUAL: 'Anual'
        }
    },
    HEADER: {
        TITLE: 'Fina.',
        SOON: 'Próximamente',
        SOON_NOTIFICATIONS: 'Próximamente - Notificaciones',
        FILTERS: {
            PERSONAL: 'Personal',
            BUSINESS: 'Business'
        }
    },
    TRANSACTION_DETAIL: {
        TITLE: 'Detalle de Transacción',
        TYPE: {
            INCOME: 'Ingreso',
            EXPENSE: 'Gasto',
            SAVING: 'Ahorro'
        },
        ACTIONS: {
            ACCEPT: 'Aceptar',
            DELETE: 'Eliminar',
            VIEW_FIXED_EXPENSE: 'Ver gasto fijo'
        }
    },
    GROUPS: {
        TITLE: 'Mis grupos',
        SUBTITLE: 'Gestiona tus grupos y gastos compartidos',
        NEW_GROUP: 'Crear grupo',
        BALANCE: 'Balance',
        MEMBERS: 'Miembros',
        ROLE: {
            ADMIN: 'Admin',
            MEMBER: 'Invitado'
        },
        BALANCE_STATUS: {
            POSITIVE: 'Te deben',
            NEGATIVE: 'Debés',
            ZERO: 'Estás al día'
        },
        EMPTY_STATE: {
            TITLE: 'No tenés grupos',
            MESSAGE: 'Creá tu primer grupo para compartir gastos'
        },
        ACTIONS: {
            CREATE_SUCCESS: 'Grupo creado correctamente',
            UPDATE_SUCCESS: 'Grupo actualizado correctamente',
            DELETE_SUCCESS: 'Grupo eliminado correctamente',
            CREATE_ERROR: 'Error al crear el grupo',
            UPDATE_ERROR: 'Error al actualizar el grupo',
            DELETE_ERROR: 'Error al eliminar el grupo',
            LOAD_ERROR: 'Error al cargar los grupos',
            SET_DEFAULT_SUCCESS: 'Configuración del grupo actualizada',
            SET_DEFAULT_ERROR: 'Error al actualizar la configuración del grupo'
        },
        SET_AS_DEFAULT: 'Establecer como predeterminado',
        REMOVE_DEFAULT: 'Quitar predeterminado',
        DEFAULT_BADGE: 'Predeterminado',
        SET_AS_DEFAULT_ADDON: 'Establecer como predeterminado',
        CONFIRM: {
            DELETE_TITLE: '¿Estás seguro de que deseas eliminar el grupo "{0}"?',
            DELETE_MESSAGE: 'Esta acción no se puede deshacer.'
        }
    },
    GROUP_DETAIL: {
        TITLE: 'Detalle del grupo',
        SECTIONS: {
            MEMBERS: 'Miembros',
            BALANCES: 'Resumen de deudas',
            TRANSACTIONS: 'Transacciones',
            FIXED_EXPENSES: 'Gastos Fijos'
        },
        EMPTY: {
            MEMBERS: 'Sin miembros',
            BALANCES: 'No hay deudas pendientes',
            TRANSACTIONS: 'Sin transacciones',
            FIXED_EXPENSES: 'No hay gastos fijos compartidos'
        },
        BALANCE_LABEL: {
            OWES: 'le debe a',
        },
        CONFIRM: {
            LEAVE_TITLE: '¿Querés abandonar el grupo?',
            LEAVE_MESSAGE: 'Vas a dejar de ver este grupo y sus transacciones.',
            LEAVE_MULTI_TITLE: '¿Qué querés hacer?',
            LEAVE_MULTI_MESSAGE: 'Hay otros miembros en el grupo. Podés abandonar el grupo o abandonarlo y eliminarlo para todos.',
            REMOVE_MEMBER_TITLE: '¿Eliminar a {0} del grupo?',
            REMOVE_MEMBER_MESSAGE: 'Esta acción no se puede deshacer.'
        },
        JOINED: 'Se unió el',
        SETTLE: {
            BUTTON: 'Saldar deuda',
            CONFIRM_TITLE: '¿Confirmar pago?',
            CONFIRM_PAYMENT: 'Confirmar pago',
            CONFIRM_YES: 'Saldar',
            CONFIRM_BUTTON: 'Confirmar',
            CANCEL: 'Cancelar',
            AMOUNT_LABEL: 'Monto a saldar',
            SUCCESS: 'Deuda saldada correctamente',
            ERROR: 'No se pudo registrar el pago',
            INLINE_ERROR: 'Error al registrar. Intentá de nuevo.',
            ERROR_SELF: 'No podés saldar una deuda con vos mismo',
            ERROR_NOT_MEMBER: 'Ambos usuarios deben ser miembros del grupo',
            ERROR_AMOUNT: 'El monto debe ser mayor a 0'
        },
        ACTIONS: {
            INVITE: 'Invitar miembros',
            INVITE_SHORT: 'Invitar',
            INVITE_GENERATING: 'Generando...',
            INVITE_COPIED: '¡Copiado!',
            LEAVE: 'Abandonar grupo',
            DELETE: 'Eliminar grupo',
            LEAVE_AND_DELETE: 'Abandonar y eliminar',
            LEAVE_ONLY: 'Solo abandonar',
            COPY_LINK: 'Copiar link',
            LINK_COPIED: '¡Copiado!',
            EDIT_TXN: 'Editar',
            DELETE_TXN_TITLE: 'Eliminar transacción',
            DELETE_TXN_MESSAGE: '¿Eliminás "{0}"? Esta acción no se puede deshacer.',
            DELETE_TXN_SUCCESS: 'Transacción eliminada',
            DELETE_TXN_ERROR: 'No se pudo eliminar la transacción',
            UPDATE_NAME_SUCCESS: 'Nombre actualizado a "{0}"',
            UPDATE_NAME_ERROR: 'No se pudo actualizar el nombre',
            REMOVE_MEMBER_SUCCESS: '{0} fue eliminado del grupo',
            REMOVE_MEMBER_ERROR: 'No se pudo eliminar al miembro',
            ADD_FIXED_EXPENSE: 'Agregar gasto fijo',
            SETTINGS: 'Configuración del grupo',
            MY_INCOME: 'Tu ingreso'
        },
        INCOME_REMINDER: {
            BUTTON: 'Recordarle',
            SUCCESS: 'Le avisamos que complete su ingreso.',
            ALREADY_SET_ERROR: 'Ese miembro ya completó su ingreso',
            RATE_LIMITED_ERROR: 'Ya le avisaste hoy'
        },
        FIXED_PERCENTAGES_WARNING: {
            MESSAGE: 'Faltan configurar los porcentajes de reparto.',
            CTA: 'Configurar'
        },
        HEADER: {
            CREATED_AT: 'Creado el',
            MEMBER_SINGULAR: 'miembro',
            MEMBER_PLURAL: 'miembros',
            STATS_TOTAL_MONTH: 'Total mes',
        },
        TRANSACTIONS: {
            SUBTITLE: 'movimientos en este grupo',
            FILTER_ALL: 'Todas',
            FILTER_MINE: 'Mías',
            PAID_BY: 'Pagó',
            TYPE_TRANSFER: 'Transferencia',
            TYPE_SHARED: 'Compartido',
        },
        DEBTS: {
            TITLE: 'Quién le debe a quién',
            SETTLED_TITLE: 'Todos los saldos están al día',
        },
        MEMBERS: {
            YOU: 'Vos',
        },
        FIXED_EXPENSE_SPLITS: {
            MEMBER: 'Integrante',
            PARTICIPATION: 'Participación',
            SHARE: 'Le toca',
            UNKNOWN_MEMBER: 'Miembro',
        },
        FIXED_EXPENSES_SUMMARY: {
            TITLE: 'Aporte total por miembro',
            MONTHLY_CHIP: 'por mes',
            TOTAL_ROW: 'Total del grupo',
            FOOTNOTE: 'Semanales y anuales se muestran como equivalente mensual.',
            LOADING: 'Calculando totales…',
            ERROR: 'No pudimos calcular los totales',
            RETRY: 'Reintentar',
        }
    },
    GROUP_FORM: {
        TITLE: {
            NEW: 'Nuevo grupo',
            EDIT: 'Editar grupo'
        },
        LABELS: {
            NAME: 'Nombre',
            PARTICIPANTS: 'Participantes',
            SEARCH_PLACEHOLDER: 'Buscá por mail o número de teléfono',
            DIVISION: 'División predeterminada',
            YOU: '(vos)',
            FIXED_PERCENTAGES: 'Porcentaje por integrante'
        },
        PLACEHOLDERS: {
            NAME: 'Ingresá el nombre del grupo'
        },
        BUTTONS: {
            GENERATE_LINK: 'Generar link de invitación',
            CREATE: 'Crear',
            CANCEL: 'Cancelar',
            SAVE: 'Guardar cambios'
        },
        DIVISION_OPTIONS: {
            EQUAL: 'Partes iguales',
            CUSTOM: 'Personalizado'
        },
        PENDING: 'Pendiente',
        DIVISION_CARDS: {
            EQUAL: {
                TITLE: 'Equitativo',
                DESCRIPTION: 'Todo se divide en partes iguales entre los miembros.',
                BADGE: 'Equitativo'
            },
            INCOME: {
                TITLE: 'Según ingresos',
                DESCRIPTION: 'Cada uno aporta en proporción a lo que gana.',
                BADGE: 'Según ingresos'
            },
            FIXED: {
                TITLE: 'Porcentaje fijo',
                DESCRIPTION: 'Ustedes eligen el porcentaje de cada uno.',
                BADGE: 'Fijo'
            },
            COMMON: {
                TITLE: 'Todo en común',
                DESCRIPTION: 'Es todo nuestro: sin deudas, solo seguimiento.',
                BADGE: 'En común'
            }
        },
        CURRENCY: {
            LABEL: 'Moneda del grupo',
            ARS: 'ARS',
            USD: 'USD'
        },
        NOTICE: {
            DIVISION_CHANGE: 'El cambio aplica a los gastos nuevos. Los ya cargados no se modifican.'
        },
        FIXED_PERCENTAGES_SUM_LABEL: 'Suma: {0}%',
        FIXED_PERCENTAGES_ERROR: 'Los porcentajes deben sumar 100%',
        FIXED_PERCENTAGES_HINT: 'Vas a poder configurar los porcentajes cuando el grupo tenga más de un integrante.'
    },
    UPCOMING_EXPENSES: {
        EMPTY_STATE: {
            ICON: 'check_circle',
            MESSAGE: 'Estás al día!'
        }
    },
    MONTHLY_SPEND_SUMMARY: {
        TITLE: 'Resumen de Gastos del Mes',
        TOTAL_LABEL: 'Total Gastos del Mes',
        ESTIMATED_LABEL: 'Estimado'
    },
    HELP_PAGE: {
        TITLE: 'Centro de Ayuda',
        SUBTITLE: '¿En qué podemos ayudarte hoy?',
        SEARCH_PLACEHOLDER: 'Buscá artículos, tutoriales o dudas...',
        FAQ: {
            TITLE: 'Preguntas Frecuentes',
            ITEMS: [
                {
                    QUESTION: '¿Cómo agrego una nueva transacción?',
                    ANSWER: 'Podés agregar una nueva transacción desde el Inicio o la página de Transacciones tocando "Nueva transacción". Podés hacerlo completando los campos manualmente o dejándole a nuestra IA el trabajo explicándole tus gastos con texto.'
                },
                {
                    QUESTION: '¿Cómo funcionan los grupos?',
                    ANSWER: 'Los grupos te permiten dividir y gestionar gastos compartidos con amigos o familiares. Creá un grupo, enviá el link de invitación a amigos y Fina gestionará las deudas y saldos por ustedes.'
                },
                {
                    QUESTION: '¿Qué incluye la versión premium?',
                    ANSWER: 'Con Fina Pro accedés a todas las herramientas: tarjetas y vencimientos ilimitados, IA avanzada para transacciones mediante comprobantes/audios, y generación de reportes profundos (CSV/PDF) para tus finanzas.'
                }
            ]
        },
        CONTACT: {
            TITLE: '¿Todavía necesitás ayuda?',
            SUBTITLE: 'Nuestro equipo de soporte está del otro lado listo para atenderte.',
            BUTTON: 'Contactar a Soporte'
        }
    },
    WALLETS: {
        TITLE: 'Billeteras',
        SUBTITLE: 'Tu dinero real, organizado por cuenta',
        TOTAL_BALANCE: 'Balance total',
        NEW_WALLET: 'Nueva billetera',
        BALANCE: 'Saldo',
        DEFAULT_BADGE: 'Predeterminada',
        SET_AS_DEFAULT: 'Usar como predeterminada',
        TRANSFER: 'Transferir',
        CORRECT_BALANCE: 'Corregir saldo',
        TRANSFER_TITLE: 'Transferir desde "{0}"',
        TRANSFER_DESCRIPTION: 'Mové dinero a otra billetera. El movimiento queda registrado en el historial.',
        BALANCE_CORRECTION_TITLE: 'Corregir saldo de "{0}"',
        BALANCE_CORRECTION_DESCRIPTION: 'Ajustá el saldo para que coincida con tu cuenta real. Se registra un ajuste en el historial.',
        AMOUNT_PLACEHOLDER: '0.00',
        DESTINATION_WALLET: 'Billetera destino',
        NEW_BALANCE: 'Nuevo saldo',
        CORRECTION_NOTE: 'Motivo (opcional)',
        CORRECTION_NOTE_PLACEHOLDER: 'Ej: Corrección por diferencia en extracto bancario',
        ACTIONS: {
            CREATE_SUCCESS: 'Billetera creada correctamente',
            UPDATE_SUCCESS: 'Billetera actualizada correctamente',
            DELETE_SUCCESS: 'Billetera eliminada correctamente',
            SET_DEFAULT_SUCCESS: 'Billetera predeterminada actualizada',
            TRANSFER_SUCCESS: 'Transferencia realizada correctamente',
            CORRECTION_SUCCESS: 'Saldo corregido correctamente',
            CREATE_ERROR: 'Error al crear la billetera',
            UPDATE_ERROR: 'Error al actualizar la billetera',
            DELETE_ERROR: 'Error al eliminar la billetera',
            SET_DEFAULT_ERROR: 'Error al cambiar la billetera predeterminada',
            TRANSFER_ERROR: 'Error al realizar la transferencia',
            CORRECTION_ERROR: 'Error al corregir el saldo',
            LOAD_ERROR: 'Error al cargar las billeteras'
        },
        CONFIRM: {
            DELETE_TITLE: '¿Eliminar la billetera "{0}"?',
            DELETE_MESSAGE: 'Esta acción no se puede deshacer. Las transacciones existentes no se verán afectadas.',
        },
        FORM: {
            TITLE_NEW: 'Nueva billetera',
            TITLE_EDIT: 'Editar billetera',
            LABELS: {
                NAME: 'Nombre',
                CURRENCY: 'Moneda',
                DESCRIPTION: 'Descripción (opcional)'
            },
            PLACEHOLDERS: {
                NAME: 'Ej: Santander, Mercado Pago, Efectivo...',
                DESCRIPTION: 'Ej: Cuenta sueldo, billetera de gastos diarios...'
            }
        },
        TRANSFER_FORM: {
            AMOUNT: 'Monto a transferir',
            SELECT_DESTINATION: 'Seleccioná la billetera destino',
            DESTINATION_AMOUNT: 'Monto a recibir ({0})'
        },
        EMPTY_STATE: {
            TITLE: 'No tenés billeteras',
            MESSAGE: 'Creá tu primera billetera para registrar tu dinero real'
        },
        MOVEMENTS: {
            TITLE: 'Historial de movimientos',
            EMPTY_TITLE: 'No hay movimientos registrados todavía.',
            EMPTY_SUBTITLE: 'Las transferencias y correcciones aparecerán aquí.',
            BALANCE_LABEL: 'Saldo'
        }
    },
    ENVELOPES: {
        TITLE: 'Sobres',
        SUBTITLE: 'Organizá para qué está reservado tu dinero',
        NEW_ENVELOPE: 'Nuevo sobre',
        ALLOCATED: 'Asignado',
        TARGET: 'Meta',
        FREE_MONEY: 'Dinero libre',
        TOTAL_ALLOCATED: 'Total asignado',
        PROGRESS: 'Progreso',
        TYPES: {
            SAVING: 'Ahorro',
            EXPENSE: 'Gastos',
            INVESTMENT: 'Inversión',
        },
        FORM: {
            TITLE_NEW: 'Nuevo sobre',
            TITLE_EDIT: 'Editar sobre',
            LABELS: {
                NAME: 'Nombre',
                TYPE: 'Tipo',
                CURRENCY: 'Moneda',
                TARGET_AMOUNT: 'Meta (opcional)',
                TARGET_DATE: 'Fecha objetivo (opcional)',
                DESCRIPTION: 'Descripción (opcional)',
            },
            PLACEHOLDERS: {
                NAME: 'Ej: Viaje a Japón, Emergencias, Auto...',
                TARGET_AMOUNT: '0.00',
                DESCRIPTION: 'Ej: Fondo de ahorro para vacaciones',
            }
        },
        ALLOCATE_FORM: {
            TITLE: 'Asignar a "{0}"',
            DEALLOCATE_TITLE: 'Liberar de "{0}"',
            LABEL: 'Monto',
            PLACEHOLDER: '0.00',
        },
        RULES_FORM: {
            TITLE: 'Reglas automáticas',
            SUBTITLE: 'Cuando entra un ingreso a una billetera, asigná automáticamente un porcentaje o monto fijo a este sobre.',
            NEW_RULE: 'Nueva regla',
            WALLET_LABEL: 'Billetera origen',
            ENVELOPE_LABEL: 'Sobre destino',
            TYPE_LABEL: 'Tipo de regla',
            TYPE_PERCENTAGE: 'Porcentaje (%)',
            TYPE_FIXED: 'Monto fijo ($)',
            PERCENTAGE_LABEL: 'Porcentaje',
            AMOUNT_LABEL: 'Monto fijo',
            NO_RULES: 'No hay reglas configuradas',
            NO_RULES_HINT: 'Sin reglas. Usá el botón "+ Nueva" para crear una.',
            SELECT_WALLET_PLACEHOLDER: '— Seleccioná una billetera —',
            NO_ENVELOPES_IN_CURRENCY: '— No hay sobres en {0} —',
            NO_WALLETS_IN_CURRENCY: '— No hay billeteras en {0} —',
            AVAILABLE_LABEL: 'Disponible',
            PERCENTAGE_EXCEEDS_AVAILABLE: 'El porcentaje supera el disponible ({0}%)',
        },
        ACTIONS: {
            ALLOCATE: 'Asignar',
            DEALLOCATE: 'Liberar',
            MANAGE_RULES: 'Reglas automáticas',
            CREATE_SUCCESS: 'Sobre creado correctamente',
            UPDATE_SUCCESS: 'Sobre actualizado correctamente',
            DELETE_SUCCESS: 'Sobre eliminado correctamente',
            ALLOCATE_SUCCESS: 'Monto asignado correctamente',
            DEALLOCATE_SUCCESS: 'Monto liberado correctamente',
            RULE_CREATE_SUCCESS: 'Regla creada correctamente',
            RULE_DELETE_SUCCESS: 'Regla eliminada correctamente',
            DISTRIBUTE_SUCCESS: 'Saldo distribuido correctamente en los sobres',
            CREATE_ERROR: 'Error al crear el sobre',
            UPDATE_ERROR: 'Error al actualizar el sobre',
            DELETE_ERROR: 'Error al eliminar el sobre',
            ALLOCATE_ERROR: 'Error al asignar el monto',
            DEALLOCATE_ERROR: 'Error al liberar el monto',
            RULE_CREATE_ERROR: 'Error al crear la regla',
            RULE_DELETE_ERROR: 'Error al eliminar la regla',
            DISTRIBUTE_ERROR: 'Error al distribuir el saldo',
            LOAD_ERROR: 'Error al cargar los sobres',
        },
        CONFIRM: {
            DELETE_TITLE: '¿Eliminar el sobre "{0}"?',
            DELETE_MESSAGE: 'Se eliminarán también las reglas automáticas asociadas.',
            DELETE_RULE_TITLE: '¿Eliminar esta regla?',
            DELETE_RULE_MESSAGE: 'No se aplicará automáticamente a futuros ingresos.',
        },
        EMPTY_STATE: {
            TITLE: 'No tenés sobres',
            MESSAGE: 'Creá tu primer sobre para organizar para qué está reservado tu dinero.',
        },
        GOAL_REACHED: '¡Meta alcanzada!',
        NO_TARGET_DATE_HINT: 'Agregá una fecha objetivo para ver el ahorro mensual',
        MONTHLY_NEEDED_SUFFIX: '/ mes para llegar a la meta'
    },
    PRO_PAGE: {
        TITLE: 'Llevá Fina al próximo nivel',
        SUBTITLE: 'Desbloqueá todo el potencial de tus finanzas con Fina Pro.',
        MONTHLY: 'Mensual',
        YEARLY: 'Anual',
        SAVE_PERCENTAGE: 'Ahorrá 20%',
        FEATURES_TITLE: 'Todo lo que necesitás, sin límites',
        PLANS: {
            FREE: {
                NAME: 'Básico',
                PRICE: '$0',
                PERIOD: '/mes',
                DESCRIPTION: 'Para empezar a ordenar tus gastos del día a día.',
                FEATURES: [
                    'Registro de transacciones ilimitadas',
                    'Sincronización de 2 tarjetas y 10 Gastos Fijos',
                    'Grupos compartidos (hasta 3 activos)',
                    'Estadísticas de consumo básicas',
                    'Ingreso prompt por IA limitados (10/mes)'
                ],
                BUTTON: 'Plan Actual'
            },
            PRO: {
                NAME: 'Pro',
                PRICE: '$3.500',
                PRICE_YEARLY: '$33.600',
                PERIOD: '/mes',
                DESCRIPTION: 'Para quienes buscan el control analítico total de su plata.',
                FEATURES: [
                    'Tarjetas, gastos fijos y grupos sin límite',
                    'Reportes PDF y exportaciones Excel/CSV de meses',
                    'Inteligencia Artificial Inteligente (vía voz, o subiendo tickets)',
                    'Alertas personalizadas vía WhatsApp',
                    'Categorías personalizadas ilimitadas',
                    'Soporte técnico prioritario'
                ],
                BUTTON: 'Mejorar a Pro'
            }
        },
        TESTIMONIALS: {
            TITLE: '¿Por qué elegir Pro?'
        },
        FAQ_LINK: 'Ver preguntas frecuentes sobre suscripciones'
    },
    ADMIN: {
        TITLE: 'Administración',
        SUBTITLE: 'Gestioná qué roles tienen acceso a cada página',
        SAVING: 'Guardando...',
        HEADER_PAGE: 'Página',
        EMPTY_STATE: 'No hay permisos configurados',
        LOAD_ERROR: 'No se pudieron cargar los permisos',
        SAVE_SUCCESS: 'Permisos actualizados correctamente',
        SAVE_ERROR: 'No se pudieron guardar los permisos'
    },
    BOTTOM_BAR: {
        MENU: 'Menú',
    },
    IOS_INSTALL: {
        TITLE: 'Instalá Fina en tu iPhone',
        MESSAGE: 'Tocá {0} y luego "Agregar a Inicio" para usar Fina como una app.',
        DISMISS: 'Ahora no'
    },
    LANDING_PAGE: {
        LOGIN: 'Ingresar',
        START_FREE: 'Empezar gratis',
        HERO_TITLE_1: 'Manejá tus',
        HERO_TITLE_2: 'finanzas.',
        HERO_TITLE_3: 'Sin fricción.',
        HERO_SUBTITLE: 'La primera aplicación que realmente entiende cómo gastas. Diseñada para ser rápida, inteligente y visualmente impecable.',
        REGISTER_FREE: 'Registrate ahora',
        SEE_FEATURES: 'Ver funciones',
        FEATURES_TITLE_1: 'Más control.',
        FEATURES_TITLE_2: 'Sin complicaciones.',
        FEATURE_1_BADGE: 'Carga Inteligente',
        FEATURE_1_TITLE: 'Escribí lo que gastás. Fina hace el resto.',
        FEATURE_1_DESC: 'Olvídate de rellenar formularios aburridos. Solo escribí en qué gastaste y la IA lo categoriza.',
        FEATURE_2_TITLE: 'Estadísticas',
        FEATURE_2_DESC: 'Entendé a dónde va tu plata mes a mes.',
        FEATURE_3_TITLE: 'Grupos y Amigos',
        FEATURE_3_DESC: 'Compartí gastos y sacá cuentas sin peleas. Transparencia total.',
        FEATURE_4_TITLE: 'Tarjetas',
        FEATURE_4_DESC: 'Visualizá tus cuotas y el estado de tus consumos. Llevá un control de cada resumen.',
        FEATURE_5_TITLE: 'Sobres',
        FEATURE_5_DESC: 'Seteá metas de ahorro, organizalas y visualizá tus avances.',
        FEATURE_6_TITLE: 'Gastos Fijos',
        FEATURE_6_DESC: 'Alquiler, luz, gimnasio... Registrá todos tus gastos fijos, revisá el historial de pagos y controlá los vencimientos.',
        FEATURE_7_TITLE: 'Conversiones',
        FEATURE_7_DESC: 'Comprás o vendés dólares? Fina te deja registrar esas conversiones al instante.',
        CTA_TITLE_1: 'Hacé que tu plata',
        CTA_TITLE_2: 'tenga sentido.',

        WHATSAPP_HERO_CTA: 'Contale tus gastos a Fina',
        WHATSAPP_SECTION_BADGE: 'Novedad',
        WHATSAPP_SECTION_TITLE: 'Registrá tus gastos directo desde WhatsApp',
        WHATSAPP_SECTION_SUBTITLE: 'Mandá un mensaje y Fina lo registra por vos. Sin abrir la app, sin formularios.',
        WHATSAPP_SECTION_CTA: 'Hablale a Fina',
        WHATSAPP_SECTION_NUMBER: '+54 9 2262 67-6092',

        FOOTER_COPYRIGHT: '© 2026 Fina Gastos.',
        FOOTER_DEVS: 'Desarrollado por Lautaro y Tomás Luna'
    },
    PRIVACY_POLICY: {
        CONTENT: `
            <h1>Privacy Policy</h1>
            <p>Last updated: December 29, 2025</p>
            <p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</p>
            <p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the <a href="https://www.privacypolicies.com/privacy-policy-generator/" target="_blank">Privacy Policy Generator</a>.</p>
            <h2>Interpretation and Definitions</h2>
            <h3>Interpretation</h3>
            <p>The words whose initial letters are capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>
            <h3>Definitions</h3>
            <p>For the purposes of this Privacy Policy:</p>
            <ul>
                <li><p><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</p></li>
                <li><p><strong>Affiliate</strong> means an entity that controls, is controlled by, or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</p></li>
                <li><p><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Astral.</p></li>
                <li><p><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</p></li>
                <li><p><strong>Country</strong> refers to: Argentina</p></li>
                <li><p><strong>Device</strong> means any device that can access the Service such as a computer, a cell phone or a digital tablet.</p></li>
                <li><p><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</p></li>
                <li><p><strong>Service</strong> refers to the Website.</p></li>
                <li><p><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</p></li>
                <li><p><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</p></li>
                <li><p><strong>Website</strong> refers to Astral, accessible from <a href="https://astral-logic.net/" rel="external nofollow noopener" target="_blank">https://astral-logic.net/</a></p></li>
                <li><p><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</p></li>
            </ul>
            <h2>Collecting and Using Your Personal Data</h2>
            <h3>Types of Data Collected</h3>
            <h4>Personal Data</h4>
            <p>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</p>
            <ul>
                <li><p>Phone number</p></li>
                <li><p>Usage Data</p></li>
            </ul>
            <h4>Usage Data</h4>
            <p>Usage Data is collected automatically when using the Service.</p>
            <p>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
            <p>When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device's unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.</p>
            <p>We may also collect information that Your browser sends whenever You visit Our Service or when You access the Service by or through a mobile device.</p>
            <h4>Tracking Technologies and Cookies</h4>
            <p>We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies We use include beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:</p>
            <ul>
                <li><strong>Cookies or Browser Cookies.</strong> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies.</li>
                <li><strong>Web Beacons.</strong> Certain sections of our Service and our emails may contain small electronic files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the Company, for example, to count users who have visited those pages or opened an email and for other related website statistics (for example, recording the popularity of a certain section and verifying system and server integrity).</li>
            </ul>
            <p>Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser. Learn more about cookies on the <a href="https://www.privacypolicies.com/blog/privacy-policy-template/#Use_Of_Cookies_Log_Files_And_Tracking" target="_blank">Privacy Policies website</a> article.</p>
            <p>We use both Session and Persistent Cookies for the purposes set out below:</p>
            <ul>
                <li>
                    <p><strong>Necessary / Essential Cookies</strong></p>
                    <p>Type: Session Cookies</p>
                    <p>Administered by: Us</p>
                    <p>Purpose: These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.</p>
                </li>
                <li>
                    <p><strong>Cookies Policy / Notice Acceptance Cookies</strong></p>
                    <p>Type: Persistent Cookies</p>
                    <p>Administered by: Us</p>
                    <p>Purpose: These Cookies identify if users have accepted the use of cookies on the Website.</p>
                </li>
                <li>
                    <p><strong>Functionality Cookies</strong></p>
                    <p>Type: Persistent Cookies</p>
                    <p>Administered by: Us</p>
                    <p>Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.</p>
                </li>
            </ul>
            <p>For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy.</p>
            <h3>Use of Your Personal Data</h3>
            <p>The Company may use Personal Data for the following purposes:</p>
            <ul>
                <li><p><strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.</p></li>
                <li><p><strong>To manage Your Account:</strong> to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.</p></li>
                <li><p><strong>For the performance of a contract:</strong> the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.</p></li>
                <li><p><strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.</p></li>
                <li><p><strong>To provide You</strong> with news, special offers, and general information about other goods, services and events which We offer that are similar to those that you have already purchased or inquired about unless You have opted not to receive such information.</p></li>
                <li><p><strong>To manage Your requests:</strong> To attend and manage Your requests to Us.</p></li>
                <li><p><strong>For business transfers:</strong> We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.</p></li>
                <li><p><strong>For other purposes:</strong> We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.</p></li>
            </ul>
            <p>We may share Your personal information in the following situations:</p>
            <ul>
                <li><strong>With Service Providers:</strong> We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.</li>
                <li><strong>For business transfers:</strong> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.</li>
                <li><strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.</li>
                <li><strong>With business partners:</strong> We may share Your information with Our business partners to offer You certain products, services or promotions.</li>
                <li><strong>With other users:</strong> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.</li>
                <li><strong>With Your consent:</strong> We may disclose Your personal information for any other purpose with Your consent.</li>
            </ul>
            <h3>Retention of Your Personal Data</h3>
            <p>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</p>
            <p>The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer periods.</p>
            <h3>Transfer of Your Personal Data</h3>
            <p>Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ from those from Your jurisdiction.</p>
            <p>Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.</p>
            <p>The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.</p>
            <h3>Delete Your Personal Data</h3>
            <p>You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.</p>
            <p>Our Service may give You the ability to delete certain information about You from within the Service.</p>
            <p>You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.</p>
            <p>Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.</p>
            <h3>Disclosure of Your Personal Data</h3>
            <h4>Business Transactions</h4>
            <p>If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.</p>
            <h4>Law enforcement</h4>
            <p>Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</p>
            <h4>Other legal requirements</h4>
            <p>The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</p>
            <ul>
                <li>Comply with a legal obligation</li>
                <li>Protect and defend the rights or property of the Company</li>
                <li>Prevent or investigate possible wrongdoing in connection with the Service</li>
                <li>Protect the personal safety of Users of the Service or the public</li>
                <li>Protect against legal liability</li>
            </ul>
            <h3>Security of Your Personal Data</h3>
            <p>The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially reasonable means to protect Your Personal Data, We cannot guarantee its absolute security.</p>
            <h2>Children's Privacy</h2>
            <p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.</p>
            <p>If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.</p>
            <h2>Links to Other Websites</h2>
            <p>Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.</p>
            <p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>
            <h2>Changes to this Privacy Policy</h2>
            <p>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.</p>
            <p>We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.</p>
            <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
            <h2>Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, You can contact us:</p>
            <ul>
                <li>By visiting this page on our website: <a href="https://astral-logic.net/" rel="external nofollow noopener" target="_blank">https://astral-logic.net/</a></li>
            </ul>
        `
    },
    TERMS_AND_CONDITIONS: {
        BACK_BUTTON: 'Volver',
        CONTENT: `
            <h1>Términos y Condiciones</h1>
            <p>Última actualización: 16 de Abril de 2026</p>
            <p>Por favor, leé detenidamente estos Términos y Condiciones ("Términos", "Términos y Condiciones") antes de utilizar la aplicación web Fina (el "Servicio") operada por Fina Gastos ("nosotros", "nuestro").</p>
            <p>Tu acceso y uso del Servicio está condicionado a tu aceptación y cumplimiento de estos Términos. Estos Términos se aplican a todos los visitantes, usuarios y otras personas que acceden o utilizan el Servicio.</p>
            
            <h2>1. Uso del Servicio</h2>
            <p>Fina es una herramienta diseñada para ayudarte a registrar, categorizar y analizar tus gastos personales. <strong>Fina no proporciona asesoramiento financiero ni legal.</strong> Cualquier decisión financiera que tomes basada en la información mostrada en Fina es bajo tu propia responsabilidad.</p>
            
            <h2>2. Cuentas de Usuario</h2>
            <p>Al crear una cuenta con nosotros, debés proporcionarnos información precisa, completa y actualizada en todo momento. El incumplimiento de esto constituye una violación de los Términos, lo que puede resultar en la terminación inmediata de tu cuenta en nuestro Servicio.</p>
            <p>Sos responsable de salvaguardar la contraseña que utilizás para acceder al Servicio y de cualquier actividad o acción bajo tu contraseña.</p>
            
            <h2>3. Contenido Generado</h2>
            <p>A través de nuestra inteligencia artificial o carga manual, podés ingresar gastos, descripciones y montos. Nos reservamos el derecho, pero no la obligación, de monitorear o eliminar el contenido que consideremos inapropiado o que viole estos términos, aunque el objetivo principal es asegurar el correcto funcionamiento técnico de tu perfil.</p>
            
            <h2>4. Discrepancias y Errores de la IA</h2>
            <p>Fina utiliza inteligencia artificial para interpretar comandos de texto y voz y convertirlos en registros de gastos estructurados. Aunque nos esforzamos por lograr la máxima precisión, <strong>la IA puede cometer errores</strong> al extraer montos o categorías. Es tu responsabilidad revisar las transacciones cargadas y corregirlas si es necesario. No seremos responsables por cálculos erróneos derivados de datos mal interpretados por el usuario o por la plataforma.</p>

            <h2>5. Propiedad Intelectual</h2>
            <p>El Servicio y su contenido original, características y funcionalidad son y seguirán siendo propiedad exclusiva de Fina Gastos y sus licenciantes. El Servicio está protegido por derechos de autor, marcas comerciales y otras leyes de la República Argentina y países extranjeros. Nuestras marcas comerciales no se pueden usar en conexión con ningún producto o servicio sin el consentimiento previo por escrito de Fina.</p>

            <h2>6. Enlaces a Otros Sitios Web</h2>
            <p>Nuestro Servicio puede contener enlaces a sitios web o servicios de terceros que no son propiedad ni están controlados por Fina Gastos.</p>
            <p>No tenemos control sobre, y no asumimos ninguna responsabilidad por el contenido, las políticas de privacidad o las prácticas de sitios web o servicios de terceros. Reconocés y aceptás firmemente que no seremos responsables ni directa ni indirectamente, por ningún daño o pérdida causada o supuestamente causada por o en conexión con el uso o la dependencia de dicho contenido, bienes o servicios disponibles en o a través de dichos sitios web o servicios.</p>

            <h2>7. Terminación</h2>
            <p>Podemos rescindir o suspender tu cuenta de inmediato, sin previo aviso ni responsabilidad, por cualquier motivo, incluido, entre otros, si incumplís los Términos.</p>
            <p>Tras la terminación, tu derecho a utilizar el Servicio cesará de inmediato. Si deseás cancelar tu cuenta, podés dejar de utilizar el Servicio o solicitar la eliminación de tus datos a través de la plataforma.</p>

            <h2>8. Limitación de Responsabilidad</h2>
            <p>En ningún caso Fina Gastos, ni sus directores, empleados, socios, agentes, proveedores o afiliados, serán responsables de ningún daño indirecto, incidental, especial, consecuente o punitivo, incluyendo, sin limitación, la pérdida de beneficios, datos, uso, fondo de comercio, u otras pérdidas intangibles, que resulten de (i) tu acceso, uso o la incapacidad de acceder o utilizar el Servicio; (ii) cualquier conducta o contenido de un tercero en el Servicio; (iii) cualquier contenido obtenido del Servicio; y (iv) el acceso no autorizado, el uso o la alteración de tus transmisiones o contenido.</p>

            <h2>9. Modificaciones</h2>
            <p>Nos reservamos el derecho, a nuestra entera discreción, de modificar o reemplazar estos Términos en cualquier momento. Si una revisión es importante, intentaremos proporcionar un aviso con al menos 30 días de antelación antes de que entren en vigencia los nuevos términos. Lo que constituye un cambio material se determinará a nuestra entera discreción.</p>

            <h2>Contacto</h2>
            <p>Si tenés alguna pregunta sobre estos Términos, podés contactarnos a través de nuestra plataforma web.</p>
        `
    },
    INCOME_MODAL: {
        TITLE: 'Tu ingreso',
        BACK: 'Atrás',
        LOADING: {
            MESSAGE: 'Calculando tu ingreso con tus últimos 3 meses…'
        },
        WITH_HISTORY: {
            RESOLVED_MESSAGE: 'Usamos {0} como tu ingreso mensual, calculado con el promedio de tus últimos 3 meses.',
            RESOLVED_MESSAGE_MANUAL: 'Usamos {0} como tu ingreso mensual, el monto que configuraste.',
            PRIVACY_NOTE: 'Solo vos ves este monto. Los demás miembros ven únicamente el porcentaje resultante.',
            CHANGE_VALUE: 'Cambiar valor',
            CONFIRM: 'Confirmar'
        },
        NO_HISTORY: {
            MESSAGE: 'No encontramos ingresos en los últimos 3 meses. Ingresá tu ingreso mensual para poder dividir según ingresos.',
            HELPER: 'Completalo para continuar'
        },
        CHANGE_VALUE: {
            LABEL: 'Ingreso mensual',
            CANCEL: 'Cancelar',
            SAVE: 'Guardar',
            ERROR_INVALID_AMOUNT: 'Ingresá un monto mayor a 0.',
            ERROR_SAVE: 'No pudimos guardar tu ingreso. Probá de nuevo.'
        },
        SUCCESS: 'Ingreso actualizado correctamente'
    }
};
